var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"more",staticClass:"morelist"},[_c('div',{ref:"more1",staticClass:"more_list"},[_c('p',{staticClass:"list_p1"},[_vm._v(_vm._s(_vm.daTa.notice_title))]),_c('p',{staticClass:"list_p2"},[_vm._v(_vm._s(_vm.daTa.ctime))]),_c('div',{attrs:{"id":"more_html"},domProps:{"innerHTML":_vm._s(_vm.daTa.notice_content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }